import { useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { SkcUserGroupDetailsContainer } from '~features/access';

import PageNotFoundPage from '../other/pageNotFoundPage';
import Page from '../page';

const SkcUserGroupDetailsPage = () => {
	const { t } = useTranslation();
	const { id } = useParams();

	if (!id) {
		return <PageNotFoundPage />;
	}

	return (
		<Page title={`${t('accessGroup')} ${t('ui.details').toLowerCase()} ${id}`}>
			<SkcUserGroupDetailsContainer id={id} />
		</Page>
	);
};

export default SkcUserGroupDetailsPage;
